// @ts-strict-ignore
import {Directive, ElementRef, Input, OnChanges, SimpleChanges} from "@angular/core";

@Directive({
	selector: "[mediaIsPlaying]",
	standalone: false,
})
export class MediaPlayDirective implements OnChanges {
	@Input("mediaIsPlaying") isPlaying: boolean;

	constructor(private elRef: ElementRef<HTMLVideoElement | HTMLAudioElement>) {}

	public async ngOnChanges(changes: SimpleChanges) {
		if (this.isPlaying === true) {
			await this.elRef.nativeElement.play();
		} else {
			this.elRef.nativeElement.pause();
		}
	}
}
